import { createAction } from '@reduxjs/toolkit';

export const setAppSessionId = createAction<string, 'SET_APP_SESSION_ID'>('SET_APP_SESSION_ID');
